var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classnames from 'classnames';
import React, { useMemo } from 'react';
import { createPrefixCls } from '../_utils/string';
const prefixCls = createPrefixCls('loading');
export const Loading = (_a) => {
    var { className, text, vertical, block } = _a, restProps = __rest(_a, ["className", "text", "vertical", "block"]);
    const loadingCls = useMemo(() => {
        return classnames([
            prefixCls(),
            vertical ? prefixCls('vertical') : prefixCls('horizontal'),
            { [prefixCls('block')]: block },
            className
        ]);
    }, [block, className, vertical]);
    return (React.createElement("div", Object.assign({ className: loadingCls }, restProps),
        React.createElement("div", { className: prefixCls('spinner') }),
        text && React.createElement("div", { className: prefixCls('text') }, text)));
};
export default Loading;
